import { Component, input, TemplateRef, output, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';

export class DynamicCardData {
  constructor(
    public title: string,
    public subtitle?: string,
    public body?: string,
    public headerTemplate?: TemplateRef<any>,
    public bodyTemplate?: TemplateRef<any>,
  ){}
}

@Component({
  selector: 'app-lt-scroll-cards',
  imports: [MatCardModule, CommonModule],
  templateUrl: './lt-scroll-cards.component.html',
  styleUrl: './lt-scroll-cards.component.scss',
})
export class LtScrollCardsComponent {
  cardClick = output<any>();
  noItemsMessage = input<string>('No items to display.');
  items = input<any[]>([]);
  cardDataList = input<DynamicCardData[]>([]);
  displayHeaderFn = input<(item: any) => string>();
  displaySubTitleFn = input<(item: any) => string>();
  trackingField = input.required<string | ((item: any) => any)>();
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() headerTemplate: TemplateRef<any>;

  getTrackingValue(item: any): string | number {
    const tracker = this.trackingField();
    if (typeof tracker === 'function') {
      return tracker(item);
    }
    return item[tracker];
  }

  displayFn = (item: any): string => {
    return item ? this.displayHeaderFn()(item): '';
  };

  displaySubTitle = (item: any): string => {
    return item ? this.displaySubTitleFn()(item): '';
  };

  onCardClick(item: any) {
    this.cardClick.emit(item);
  }
}
